<template>
  <div class="app-main__inner">
    <TituloComponent
      icono-titulo="fas fa-pencil-alt"
      texto-titulo="Editar Categoria"
    ></TituloComponent>
    <div class="main-card mb-3 card col-12 col-md-8 offset-md-2">
      <div class="card-body">
        <form @submit.prevent="guardarCategoria()">
          <float-label label="Código:" clase>
            <input
              v-model="categoria.codigo"
              id="codigo"
              placeholder="Ingresar una descripción..."
              type="text"
              class="form-control"
              :class="enviado && !$v.categoria.codigo.required ? 'is-invalid' : ''"
            />
            <template v-slot:validation>
              <div
                class="invalid-feedback"
                v-if="enviado && !$v.categoria.codigo.required"
              >
                Debe ingresar una descripción
              </div>
            </template>
          </float-label>
          <float-label label="Descripción:" clase>
            <input
              v-model="categoria.descripcion"
              id="descripcion"
              placeholder="Ingresar una descripción..."
              type="text"
              class="form-control"
              :class="
                enviado && !$v.categoria.descripcion.required
                  ? 'is-invalid'
                  : ''
              "
            />
            <template v-slot:validation>
              <div
                class="invalid-feedback"
                v-if="enviado && !$v.categoria.descripcion.required"
              >
                Debe ingresar una descripción
              </div>
            </template>
          </float-label>
          <button class="mt-1 btn btn-info float-right">Guardar</button>
        </form>
      </div>
    </div>
  </div>
</template>
<script>
import TituloComponent from "@/components/layouts/TituloComponente";
import FloatLabel from "@/components/layouts/FloatLabel";
import { required } from 'vuelidate/lib/validators';
import axios from "axios";
import Swal from "sweetalert2";
import Categoria from "@/models/categoria";
export default {
  name: "EditarCategoria",
  components: {
    TituloComponent,
    FloatLabel,
  },
  data() {
    return {
      categoria: new Categoria(null, "", ""),
      loading: false,
      enviado: false,
    };
  },
  validations: {
    categoria: {
      codigo: { required },
      descripcion: { required },
    },
  },
  mounted() {
    this.categoria.id = this.$route.params.id;
    this.getCategoria();
  },
  methods: {
    getCategoria() {
      this.loading = true;
      axios
        .get("categorias/" + this.categoria.id)
        .then((res) => {
          console.log(res.data);
          if (res.data.success) {
            this.categoria = res.data.categoria;
          }
        })
        .catch(() => {
          Swal.fire({
            icon: "warning",
            title: "Oopss..",
            text: `No se ha encontrado categorias.`,
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    guardarCategoria() {
      this.enviado = true;
      this.loading = true;
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.loading = false;
        return false;
      }
      axios
        .put("/categorias/" + this.categoria.id, this.categoria)
        .then((res) => {
          if (res.data.success) {
            Swal.fire({
              icon: "success",
              title: "Éxito",
              text: `${res.data.categoria.descripcion} se editó con éxito.`,
            });
            this.$router.push({ name: "ListarCategorias" });
          }
        })
        .catch((error) => {
          console.log(error);
          Swal.fire({
            icon: "error",
            title: "Oopss..",
            text: `No se ha podido completar la operación.`,
          });
        })
        .finally(() => (this.loading = false));
    },
  },
};
</script>